(() => {
  'use strict';
  if (window.avonticSetupChooser) return;
  window.avonticSetupChooser = true;
  const cache = new Map();
  const latest = new WeakMap();
  const visible = card => !card.closest('[hidden]') && (!card.closest('details') || card.closest('details').open);
  const parse = node => { try { return JSON.parse(node?.textContent || '{}'); } catch (_) { return {}; } };
  async function quote(url, handle, choices) {
    const endpoint = new URL(url, location.origin);
    endpoint.searchParams.set('view', 'avontic-setup-quote');
    const key = endpoint.toString();
    if (!cache.has(key)) {
      const request = fetch(endpoint, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) })
        .then(response => { if (!response.ok) throw new Error('request'); return response.json(); })
        .catch(error => { cache.delete(key); throw error; });
      cache.set(key, request);
      if (cache.size > 100) cache.delete(cache.keys().next().value);
    }
    const result = await cache.get(key);
    if (result.handle !== handle || !result.variant || !Number.isFinite(result.variant.price) || !choices.every(item => item.position < 1 || result.variant.options[item.position - 1] === item.value.name)) throw new Error('selection');
    return result;
  }
  async function render(card, detail) {
    const root = card.closest('[data-av-family-chooser]');
    const price = card.querySelector('[data-av-setup-price]');
    const delta = card.querySelector('[data-av-setup-delta]');
    if (!root || !price || !delta) return;
    const labels = parse(root.querySelector('[data-av-setup-labels]'));
    const signature = detail.selected.map(value => value?.id || '').join(',') + '|' + (detail.targetUrl || 'review');
    const previous = latest.get(card);
    latest.set(card, { detail, signature });
    if (previous?.signature !== signature) {
      price.textContent = card.dataset.avSetupPriceBase;
      delta.textContent = detail.current ? '' : detail.result.blocked || detail.result.questions?.length ? labels.review : '';
      delete card.dataset.avSetupQuoted;
    }
    if (!visible(card) || card.dataset.avSetupQuoted === signature) return;
    if (!detail.current && (detail.result.blocked || detail.result.questions.length)) return;
    const sourceChoices = detail.selected.map((value, index) => ({ value, position: detail.source.options[index].position }));
    if (sourceChoices.some(choice => !choice.value)) return;
    const stillCurrent = () => card.isConnected && latest.get(card)?.signature === signature;
    try {
      const [source, target] = await Promise.all([
        quote(detail.sourceUrl, detail.source.handle, sourceChoices),
        detail.current ? null : quote(detail.targetUrl, detail.target.handle, detail.result.chosen)
      ]);
      if (!stillCurrent()) return;
      const selected = detail.current ? source : target;
      price.textContent = selected.variant.formatted;
      card.dataset.avSetupQuoted = signature;
      delta.textContent = '';
      if (!selected.variant.available) { delta.textContent = labels.unavailable; return; }
      if (detail.current || card.dataset.avSetupPack === 'true' || root.dataset.currentHandle.includes('teamready') || source.currency !== target.currency) return;
      const difference = target.variant.price - source.variant.price;
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: target.currency }).format(Math.abs(difference) / 100);
      delta.textContent = difference === 0 ? labels.same : (difference > 0 ? labels.higher : labels.lower).replace('__PRICE__', formatted);
    } catch (_) {
      if (stillCurrent()) { price.textContent = card.dataset.avSetupPriceBase; delta.textContent = detail.current ? '' : labels.review; }
    }
  }
  document.addEventListener('avontic:family-match', event => { render(event.target, event.detail); });
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.av-sc__more') || !event.target.open) return;
    event.target.querySelectorAll('[data-av-bundle-target]').forEach(card => { const state = latest.get(card); if (state) render(card, state.detail); });
  }, true);
})();
